import React, { memo } from "react";
import { View, StyleSheet } from "react-native";
import ExperienceIcons from "../../../../assets/Icons/ExperienceIcons";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../components/CustomComponent";
import { Colors } from "../../../../globalStyles/ColorConfig";

const LocationComponent = ({ location }: { location: any }) => (
  <View style={styles.container}>
    <ExperienceIcons.LocationIcon fill={Colors.gold10} />
    <CustomComponent.TextView
      title={location}
      textStyle={[
        GlobalStyles.title2,
        {
          color: "rgba(0, 0, 0, 0.3)",
          letterSpacing: -0.4,
          fontSize: 16,
          fontFamily: "InterMedium",
        },
      ]}
    />
  </View>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
  },
});

export default memo(LocationComponent);
